import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransportManagementSearchCriteria } from '../models/transport-management.model';
import { TransportManagementExportToFileStart } from './transport-management-export.actions';
import { CatalogSearchCriteriaFacade } from '../../../catalog-search-criteria/catalog-search-criteria.facade';
import { CatalogSearchCriteriaType } from '../../../catalog-search-criteria';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportFileFacade } from '../../../../../common';
import { ExportDialogComponent } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class TransportManagementExportFacade implements ExportFileFacade {
  constructor(private store: Store, private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade) {}

  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
  ): void {
    this.catalogSearchCriteriaFacade
      .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.TransportManagement)
      .subscribe((searchCriteria: TransportManagementSearchCriteria) => {
        const { viewMode, page: _page, size: _size, id: _id, name: _name, ...filter } = searchCriteria;
        this.store.dispatch(
          new TransportManagementExportToFileStart({
            reportName,
            viewMode,
            filter,
            dialogRef,
            navigationNeeded,
          }),
        );
      });
  }
}
